export const ESTOQUE_PAGE = () => "/estoque";
export const ESTOQUE_PRODUTOS_PAGE = () => "/estoque/produtos";
export const ESTOQUE_BALANCO_LOJAS_PAGE = () => "/estoque/balanco";
export const ESTOQUE_BALANCO_DETALHES_PAGE = (storeId?: string) => storeId ? `/estoque/balanco/${storeId}` : "/estoque/balanco/:storeId";
export const ESTOQUE_OCORRENCIAS_PAGE = () => "/estoque/ocorrencias";
export const ESTOQUE_RELATORIOS_PAGE = () => "/estoque/relatorios";
export const ESTOQUE_ATUAL_PAGE = () => "/estoque/estoque-atual";
export const ESTOQUE_ENTRADAS_SAIDAS_PAGE = () => "/estoque/entradas-saidas";
